import React from 'react';
import * as AsyncValue from 'utility/AsyncValue';

interface Props<T> {
  loadKey: string;
  load(key: string): void;
  value: AsyncValue.AsyncValue<T>;
  children: (value: T) => JSX.Element;
  loading: () => JSX.Element;
  errored: () => JSX.Element;
}

export function Loader<T>({
  load,
  loadKey,
  value,
  children,
  loading,
  errored,
}: Props<T>) {
  React.useEffect(() => {
    load(loadKey);
  }, [loadKey, load]);

  return AsyncValue.branch(value, {
    fetched: children,
    fetching: loading,
    error: errored,
  });
}

Loader.defaultProps = {
  loading: () => <></>,
  errored: () => <></>,
};

export default Loader;
